// extracted by mini-css-extract-plugin
export default {"root":"NewMeetingPage_root__P8FsV","header":"NewMeetingPage_header__D-abp","spinner":"NewMeetingPage_spinner__9NlKP"};